export default {
    group: {
        members: 'メンバー',
        name: 'グループ名',
        title: 'グループを作成',
        titleSub:
            '取引先に担当グループを設定すると、取引先や関連書類、レポートが所属メンバーにのみ表示されます。',
    },
    role: {
        members: 'メンバー',
        name: '役割名',
        title: '役割を作成',
        titleSub: '各メンバーに役割を割り当てることができます。',
    },
};
